module.exports = __webpack_public_path__ + "img/slider_a01_r.38adc54.16697980.png";